/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useMemo} from "react";
import DateUtils from "../../../../../../../monitoring/src/Utils/DateUtils";
import {UserFieldViewer} from "../../../../../Models/Core/ServiceDrivenViewers";

export const LastModifiedSpeciesLabel = function (props) {

    const {
        label = 'Last Modified at',
        modifiedField = 'modified',
        modifiedByUserIdField = 'modifiedByUserId'
    } = props;

    const lastModifiedSpecies = useMemo(() => {
        if (!props.data?.length) {
            return null;
        } // Early return if data is empty or undefined

        const sortedData = [...props.data].sort((a, b) =>
            DateUtils.CompareDesc(a?.[modifiedField], b?.[modifiedField], -1)
        );
        return sortedData[0]; // Return the most recent item
    }, [props.data, modifiedField]);

    const lastModifiedUserId = lastModifiedSpecies?.[modifiedByUserIdField];

    const getText = () => {
        if (!lastModifiedSpecies) return null;

        return <div className="sb-last-modified-statement">
            <span>{label} </span>
            <a className="link-primary"
               style={{textDecoration: 'underline'}}
               onClick={() => props.onDateClick(lastModifiedSpecies.speciesId)}>
                {DateUtils.FormatToLocalDate(lastModifiedSpecies[modifiedField], 'MM/dd/YYY h:mm a')}
            </a>
            {
                !!lastModifiedUserId &&
                [
                    " by ",
                    <UserFieldViewer Value={lastModifiedUserId} />,
                ]
            }
        </div>
    };

    return <div className="sb-table-filter-supplement">{getText()}</div>
};
